import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { Nav } from '@catalogo/core-nav';
import PlusSymbolRounded from '@catalogo/ui-americanas-desktop-svg/plus-symbol-rounded.svg';
import { getMoreOffersUrl } from '@catalogo/ui-americanas-mobile-offers-box/src/helpers';

export const MoreOffers = ({ offersQuantity, history, currentSku, product }) => {
  const { search: locationQuery } = history?.location;
  const { id: productId } = product;
  const iconProps = { fill: '#666', direction: 'right', width: '15', height: '15' };

  return (
    <Touchable to={getMoreOffersUrl(productId, currentSku, locationQuery)}>
      <ContentWrapper>
        <PlusSymbolRounded {...iconProps} />
        <Text>{offersQuantity} outras ofertas deste mesmo produto</Text>
      </ContentWrapper>
    </Touchable>
  );
};

const Text = styled.span`
  margin-left: 4px;
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Touchable = styled(Nav)`
  text-decoration: underline;
  padding-top: 16px;
  margin-top: 16px;
  border-top: 1px solid rgba(206, 204, 204, 0.4);
  display: flex;
  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

MoreOffers.propTypes = {
  offersQuantity: propTypes.number,
  children: propTypes.object,
  href: propTypes.string,
};

export default withRouter(MoreOffers);
